import api from "!../../../Booker.RoomDisplay/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../Booker.RoomDisplay/node_modules/css-loader/dist/cjs.js!../../../Booker.RoomDisplay/node_modules/resolve-url-loader/index.js!../../../Booker.RoomDisplay/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[3]!./views.login.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};